import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { Array2D } from "@lib/titan2/dist/util/collection/Array2D";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import { SlingoConstants } from "../enum/SlingoConstants";
import { TicketCellData } from "./TicketCellData";
/**
 * TicketData.ts
 */
export class TicketData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.id = this.data.getNumber(SlingoConstants.PROPERTY_ID);
            this.numberOfRows = this.data.getNumber(SlingoConstants.PROPERTY_NUMBER_OF_ROWS);
            this.numberOfColumns = this.data.getNumber(SlingoConstants.PROPERTY_NUMBER_OF_COLUMNS);
            this.solidifyCells();
        }
    }
    solidifyCells() {
        this.remainingCells = [];
        this.sequence = this.data.getNumberArray(SlingoConstants.PROPERTY_TICKET_DATA);
        this.cellMap = new Dictionary();
        this.cells = new Array2D(this.numberOfRows, this.numberOfColumns);
        let i = 0;
        let cellValue;
        let cell;
        for (let row = 0; row < this.numberOfRows; row++) {
            for (let column = 0; column < this.numberOfColumns; column++) {
                cellValue = this.sequence[i];
                cell = new TicketCellData(cellValue, row, column);
                this.cells.setValue(row, column, cell);
                this.cellMap.setValue(cellValue, cell);
                this.remainingCells.push(cell);
                i++;
            }
        }
    }
    call(call) {
        if (this.contains(call)) {
            let cell = this.getCell(call);
            if (!cell.isCalled()) {
                cell.setCalled(true);
            }
        }
    }
    dab(call) {
        if (this.contains(call)) {
            let cell = this.getCell(call);
            if (!cell.isDabbed()) {
                cell.setDabbed(true);
                this.remainingCells.splice(this.remainingCells.indexOf(cell), 1);
            }
        }
    }
    contains(call) {
        return this.cellMap.containsKey(call);
    }
    getId() {
        return this.id;
    }
    getSequence() {
        return this.sequence?.slice();
    }
    getCell(call) {
        return this.cellMap.getValue(call);
    }
    getCellAt(row, column) {
        return this.cells.getValue(row, column);
    }
    getNumberOfCells() {
        return this.numberOfColumns * this.numberOfRows;
    }
    getNumberOfRows() {
        return this.numberOfRows;
    }
    getNumberOfColumns() {
        return this.numberOfColumns;
    }
    getCellsRemaining() {
        return this.remainingCells.length;
    }
    getRemainingCells() {
        return this.remainingCells?.slice();
    }
}
//# sourceMappingURL=TicketData.js.map